module.exports = __webpack_public_path__ + "static/media/MRA Logo.9c2d8eb9.png";